export const shortenedLink = /^\[\[(.*?)\]\]/
